import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Permission } from 'src/app/constants/permission.constant';
import { IProduct } from 'src/app/models/products/product';
import { AuthService } from 'src/app/services/auth.service';
import { ProductsService } from 'src/app/services/products.service';

@Component({
  selector: 'app-download-wm-action',
  templateUrl: './download-wm-action.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class DownloadWmActionComponent {
  @Input() product!: IProduct;

  Permission = Permission;

  constructor(
    public authService: AuthService,
    private productsService: ProductsService,
  ) {}

  onDownload(): void {
    this.productsService.downloadWeightsAndMeasures(this.product.id!).subscribe((blob) => {
      const a = document.createElement('a');
      const url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = `${this.product.barcode}_weights-and-measures.csv`;
      a.click();
      window.URL.revokeObjectURL(url);
    });
  }
}
